import {Fragment, useEffect, useState} from "react";
import "../../assets/css/course.css"
import * as React from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import clientconfigwebapp, {check_login_appbk, scrollTo_uphk} from "../../clientconfigwebapp";

const Meeting_Lessons = (props) => {

    const [lock, setLock] = useState(true);

    const navigate = useNavigate();
    useEffect(() => {
        if (check_login_appbk() == true) {
            setLock(false);
        }


    }, [1]);


    return (
        <>

            {
                String(props.data_lessons).length == 0 ? (

                    <>

                    </>

                ) : (
                    <>

                        {

                            props.data_lessons.map((child_item_get, index) => {

                                var number_id_box = String(child_item_get.id);
                                /// var r = Math.round(Math.random()*(10-50000+1)/1);

                                ////  var calccc=(r+10);
                                ////  var number_id_box= parseInt(calccc);


                                var counter_row_child = parseInt(index) + 1

                                var class_custome_bk = "";


                                if (props.lesson_id == child_item_get.id) {
                                    class_custome_bk = " active_item_c ";
                                }


                                return (
                                    <Fragment>


                                        <div id={"boxc" + String(number_id_box)}
                                             className={"flexRowBetCenter course-item lesson-item mettings-lesson-item " + String(class_custome_bk)}>


                                            <div className="box_lesson_box_karimain">


                                                <Link className="flexRowBetCenter des-lesson" reloadDocument={true}
                                                      to={"/panel/my-course/" + String(props.cource_id_get) + "/" + String(child_item_get.id)}>
                                                    {lock === false ?
                                                        <div className="lesson-num">{counter_row_child}</div>
                                                        :

                                                        <div className="lesson-num lock-svg">
                                                            <svg className="icon_play_list_metting" width="24"
                                                                 height="24" viewBox="0 0 24 24" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                      d="M11.1374 4.51386C11.703 4.37049 12.2969 4.37049 12.8625 4.51386C14.1819 4.84832 15.1258 5.96028 15.2306 7.26587L15.1915 7.25782C13.0872 6.82413 10.9128 6.82413 8.8085 7.25782L8.76936 7.26589C8.87413 5.96028 9.81803 4.84832 11.1374 4.51386ZM16.685 7.50839V7.7184C18.1592 8.40029 19.2768 9.68843 19.6983 11.2674C20.1955 13.1297 20.0758 15.0973 19.3563 16.8896L19.2718 17.1C18.5 19.0225 16.7426 20.4054 14.6498 20.7371L13.9687 20.845C12.6648 21.0517 11.3352 21.0517 10.0313 20.845L9.35019 20.7371C7.25734 20.4054 5.49999 19.0225 4.72818 17.1L4.64368 16.8895C3.92417 15.0973 3.80447 13.1297 4.30168 11.2674C4.72321 9.68846 5.84078 8.40033 7.31494 7.71843V7.50838C7.31494 5.45953 8.7365 3.66924 10.7734 3.15292C11.5777 2.94903 12.4223 2.94903 13.2266 3.15292C15.2634 3.66924 16.685 5.45954 16.685 7.50839ZM12 12.8504C12.3192 12.8504 12.5779 13.1022 12.5779 13.4129V15.288C12.5779 15.5987 12.3192 15.8506 12 15.8506C11.6809 15.8506 11.4221 15.5987 11.4221 15.288V13.4129C11.4221 13.1022 11.6809 12.8504 12 12.8504Z"
                                                                      fill="#DC2626"/>
                                                            </svg>
                                                        </div>

                                                    }


                                                    <span>{child_item_get.title_post}</span>


                                                </Link>
                                            </div>


                                                {
                                                    lock === false ? (


                                                        <Fragment>




                                                            <div className={"flex flex-row gap-x-[8px]"}>



                                                                {
                                                                    child_item_get.video_status_active && child_item_get.video_status_active === "active" && (

                                                                <Link reloadDocument={true}
                                                                      to={"/panel/my-course/" + String(props.cource_id_get) + "/" + String(child_item_get.id)}>
                                                                    <div className="lesson-play-btn"
                                                                         style={{ border: props.post_type != "podcast" && props.lesson_id == child_item_get.id ? "solid #3b82f6" : "solid gray" }}>
                                                                        <svg
                                                                            width="30px"
                                                                            height="30px"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                                                                            <g id="SVGRepo_tracerCarrier"
                                                                               strokeLinecap="round"
                                                                               strokeLinejoin="round"/>
                                                                            <g id="SVGRepo_iconCarrier">

                                                                                <path
                                                                                    d="M4 15V9C4 7.89543 4.89543 7 6 7H13C14.1046 7 15 7.89543 15 9V15C15 16.1046 14.1046 17 13 17H6C4.89543 17 4 16.1046 4 15Z"
                                                                                    stroke="#000000"
                                                                                    strokeWidth={2}
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />

                                                                                <path
                                                                                    d="M18.3753 8.29976L15.3753 10.6998C15.1381 10.8895 15 11.1768 15 11.4806V12.5194C15 12.8232 15.1381 13.1105 15.3753 13.3002L18.3753 15.7002C19.0301 16.2241 20 15.7579 20 14.9194V9.08062C20 8.24212 19.0301 7.77595 18.3753 8.29976Z"
                                                                                    stroke="#000000"
                                                                                    strokeWidth={2}
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />

                                                                            </g>
                                                                        </svg>

                                                                    </div>
                                                                </Link>

                                                            )
                                                                }




                                                                {
                                                                    child_item_get.podcast_status_active &&  child_item_get.podcast_status_active === "active" && (

                                                                <Link reloadDocument={true}
                                                                      to={"/panel/my-course/" + String(props.cource_id_get) + "/" + String(child_item_get.id) + "/podcast" }>


                                                                <div className="lesson-play-btn"
                                                                     style={{ border: props.post_type === "podcast" && props.lesson_id == child_item_get.id ? "solid #3b82f6" : "solid gray" }}>
                                                                    <svg
                                                                        width="30px"
                                                                        height="30px"
                                                                        viewBox="0 0 24 24"
                                                                        version="1.1"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                        fill="#000000"
                                                                    >
                                                                        <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                                                                        <g id="SVGRepo_tracerCarrier"
                                                                           strokeLinecap="round"
                                                                           strokeLinejoin="round"/>
                                                                        <g id="SVGRepo_iconCarrier">

                                                                            <title>Sound</title>
                                                                            <g id="Page-1" stroke="none" strokeWidth={1}
                                                                               fill="none" fillRule="evenodd">

                                                                                <g id="Sound">

                                                                                    <rect
                                                                                        id="Rectangle"
                                                                                        fillRule="nonzero"
                                                                                        x={0}
                                                                                        y={0}
                                                                                        width={24}
                                                                                        height={24}
                                                                                    >

                                                                                    </rect>

                                                                                    <path
                                                                                        d="M21,16 L21,6.54138 C21,4.68756 19.3354,3.27743 17.5068,3.5822 L11.5068,4.5822 C10.0602,4.82329 9,6.07486 9,7.54138 L9,18"
                                                                                        id="Path"
                                                                                        stroke="#0C0310"
                                                                                        strokeWidth={2}
                                                                                        strokeLinecap="round"
                                                                                    >

                                                                                    </path>

                                                                                    <path
                                                                                        d="M6.5,21 C7.88071,21 9,19.8807 9,18.5 L9,16 L6.5,16 C5.11929,16 4,17.1193 4,18.5 C4,19.8807 5.11929,21 6.5,21 Z"
                                                                                        id="Path"
                                                                                        stroke="#0C0310"
                                                                                        strokeWidth={2}
                                                                                        strokeLinecap="round"
                                                                                    >

                                                                                    </path>

                                                                                    <path
                                                                                        d="M18.5,19 C19.8807,19 21,17.8807 21,16.5 L21,14 L18.5,14 C17.1193,14 16,15.1193 16,16.5 C16,17.8807 17.1193,19 18.5,19 Z"
                                                                                        id="Path"
                                                                                        stroke="#0C0310"
                                                                                        strokeWidth={2}
                                                                                        strokeLinecap="round"
                                                                                    >

                                                                                    </path>

                                                                                </g>

                                                                            </g>

                                                                        </g>
                                                                    </svg>

                                                                </div>

                                                                </Link>
                                                                    ) }

                                                            </div>
                                                        </Fragment>
                                                        ) :(


                                                        <div className="lesson-play-btn lesson-play-btn-locked">
                                                            <svg className="icon_play_list_metting" width="30"
                                                                 height="30"
                                                                 viewBox="0 0 30 30" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M5 15V10.55C5 5.02501 8.9125 2.76251 13.7 5.52501L17.5625 7.75001L21.425 9.97501C26.2125 12.7375 26.2125 17.2625 21.425 20.025L17.5625 22.25L13.7 24.475C8.9125 27.2375 5 24.975 5 19.45V15Z"
                                                                    fill="white" stroke="white" stroke-width="1.5"
                                                                    stroke-miterlimit="10" stroke-linecap="round"
                                                                    stroke-linejoin="round"/>
                                                            </svg>
                                                        </div>

                                                    )
                                                }

                                        </div>
                                    </Fragment>
                                );


                            })
                        }
                    </>

                )}


        </>
    );


}

export default Meeting_Lessons;
